var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBarChart = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 15,
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4115_2741)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 6.80029H11.2V13.8003H7V6.80029Z",
  stroke: "#333333",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.79883 1.2002H6.99883V13.8002H2.79883V1.2002Z",
  stroke: "#333333",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.699219 13.8003H13.2992",
  stroke: "#333333",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4115_2741"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "white",
  transform: "translate(0 0.5)"
})))));
export default SvgBarChart;